import { render, staticRenderFns } from "./DxActionMenu.vue?vue&type=template&id=a56a9850&scoped=true"
import script from "./DxActionMenu.vue?vue&type=script&lang=js"
export * from "./DxActionMenu.vue?vue&type=script&lang=js"
import style0 from "./DxActionMenu.vue?vue&type=style&index=0&id=a56a9850&prod&scoped=true&lang=css"
import style1 from "./DxActionMenu.vue?vue&type=style&index=1&id=a56a9850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a9850",
  null
  
)

export default component.exports